import SSPage from './SolicitationsSearch';

export default SSPage;



// WEBPACK FOOTER //
// ./src/pages/SolicitationsSearch/index.jsx